import TopBar from "../../../components/common/topBar/TopBar.vue";
let nowProjectId;
//按需加载
import {
  getBimDataBankCategoryTree,
  addBimDataBankCategory,
  editBimDataBankCategory,
  deleteBimDataBankCategory,
  addBimDatabankCommonCategory,
  getBimDataBankCategoryDetail,
  getBimDatabankCommonCategoryList,
  deleteBimDatabankCommonCategory,
  deleteBimDatabankCommonCategoryByCId,
} from "../../../api/api";

export default {
  name: "BimDatabankCategory",
  components: {
    TopBar,
  },
  props: {},
  data() {
    return {
      treeData: [],
      dialogFormVisible: false,
      form: {
        name: "",
        parentId: 0,
        pname: "根目录",
        description: "",
        sort: 1,
      },
      formLabelWidth: "120px",
      dialogTitle: "新增目录",
      rules: {
        parentId: [
          {
            required: true,
            message: "上级目录不能为空",
            trigger: "blur",
          },
        ],
        name: [
          {
            required: true,
            message: "请输入新增的目录名称",
            trigger: "blur",
          },
        ],
      },
      defaultProps: {
        children: "children",
        label: "text",
      },
      commonCategoryArr: [], // 常用目录id数组，方便判断选项里的目录是显示“设为常用”还是“取消常用”。
    };
  },
  mounted() {
    nowProjectId = parseInt(window.sessionStorage.getItem("nowProjectId"));

    this.refreshTree();
  },
  methods: {
    async refreshTree() {
      let that = this;

      // 获取目录
      let getCTreeData = {
        projectId: nowProjectId,
      };

      //获取常用目录
      // let getCCLData = {
      // 	ProjectId: nowProjectId,
      // }
      getBimDatabankCommonCategoryList(getCTreeData).then((res) => {
        //console.log(JSON.parse(JSON.stringify(res)));
        //console.log(222);
        if (res.data.success && res.data.data.length > 0) {
          let ccIds = [];
          res.data.data.forEach((item) => {
            ccIds.push(item.categoryId);
          });
          that.commonCategoryArr = [...new Set(ccIds)]; // 去重。
          //console.log(that.commonCategoryArr);
          //console.log(333);
        } else {
          that.commonCategoryArr = [];
        }
      });

      getBimDataBankCategoryTree(getCTreeData).then((res) => {
        // console.log(JSON.parse(JSON.stringify(res)));
        // console.log(111);
        if (res.data.success && res.data.data.length > 0) {
          that.treeData = res.data.data;
        } else {
          that.treeData = [];
        }
      });
      //console.log(that.commonCategoryArr);
    },
    goBack() {
      this.$router.push({
        path: "/bimDatabank",
      });
    },
    //append(data, newChild) {
    // this.dialogTitle = '新增目录';
    // // console.log(JSON.parse(JSON.stringify(data)));
    // // console.log(111111);
    // if (!newChild) {
    // 	newChild = {
    // 		id: id++,
    // 		label: '测试新增目录',
    // 		children: []
    // 	};
    // }
    // if (!data.children) {
    // 	this.$set(data, 'children', []);
    // }
    // data.children.push(newChild);
    //},
    append(node, data) {
      // console.log(JSON.parse(JSON.stringify(data)));
      // console.log(222222);
      this.form = {
        name: "",
        parentId: data.id,
        pname: data.text,
        description: "",
        sort: 1,
      };
      this.dialogFormVisible = true;
    },
    remove(node, data) {
      //console.log(JSON.parse(JSON.stringify(data)));
      //console.log(222222);

      // const parent = node.parent;
      // const children = parent.data.children || parent.data;
      // const index = children.findIndex(d => d.id === data.id);
      // children.splice(index, 1);

      let that = this;
      this.$confirm(
        "只允许删除其下没有资料项的目录，确认删除吗？",
        "确认提示",
        {
          distinguishCancelAndClose: true,
          confirmButtonText: "确认删除",
          cancelButtonText: "取消删除",
        }
      )
        .then(() => {
          deleteBimDataBankCategory({
            id: [data.id],
          }).then((res) => {
            //console.log(JSON.parse(JSON.stringify(res)));
            //console.log(555);
            if (res.data.success) {
              that.$message({
                message: "删除成功。",
                type: "success",
                offset: 100,
                showClose: true,
                duration: 1600,
              });
              that.refreshTree();
            } else {
              //let message = res.data.msg || '删除失败了，请检查您要删除的目录下是否还有未删除的资料项。';
              let message =
                "删除失败了，请检查您要删除的目录下是否还有未删除的资料项。";
              that.$alert(message, "删除失败", {
                confirmButtonText: "确定",
                type: "error",
                callback: (action) => {},
              });
            }
          });
        })
        .catch(function(err) {
          console.log(err);
        });
      // //console.log(node.parent.label);
      // if (node.parent.label) {
      // 	this.form.parent = node.parent.label;
      // } else {
      // 	this.form.parent = "根目录";
      // }
    },

    add() {
      (this.form = {
        name: "",
        parentId: 0,
        pname: "根目录",
        description: "",
        sort: 1,
      }),
        (this.dialogTitle = "新增目录");
      this.dialogFormVisible = true;
    },
    edit(node, data) {
      let that = this;
      getBimDataBankCategoryDetail({
        id: data.id,
      }).then((res) => {
        //console.log(JSON.parse(JSON.stringify(res)));
        //console.log(555);
        if (res.data.success) {
          that.form = {
            id: res.data.data.id,
            name: res.data.data.name,
            parentId: res.data.data.pId || 0,
            pname: res.data.data.pName || "根目录",
            description: res.data.data.description,
            sort: res.data.data.sort,
          };
          //console.log(that.form);
          that.refreshTree();
        } else {
          that.$alert(
            "尝试获取您要编辑的信息失败了，请再试一次吧~",
            "编辑失败",
            {
              confirmButtonText: "确定",
              type: "error",
              callback: (action) => {},
            }
          );
        }
      });
      // //console.log(node.parent.label);
      // if (node.parent.label) {
      // 	this.form.parent = node.parent.label;
      // } else {
      // 	this.form.parent = "根目录";
      // }
      (this.dialogTitle = "编辑目录"), (this.dialogFormVisible = true);
    },
    deleteCatalog() {
      //先判断一下已选择的目录中是否含有子目录，如果含有子目录，则提示不能删除。
      // console.log(JSON.parse(JSON.stringify(this.$refs.categoryTree.getCheckedKeys())));
      // console.log(JSON.parse(JSON.stringify(this.$refs.categoryTree.getCheckedNodes())));

      // return false;
      let that = this;
      let checkedNodes = this.$refs.categoryTree.getCheckedNodes();
      let checkedKeys = this.$refs.categoryTree.getCheckedKeys();
      if (checkedNodes.length == 0) {
        that.$alert(
          "请先勾选您要批量删除的目录，只允许删除其下没有子目录和资料项的目录。",
          "友情提示",
          {
            confirmButtonText: "确定",
            type: "error",
            callback: (action) => {},
          }
        );
      } else {
        let index = checkedNodes.findIndex((item) => {
          return item.children.length > 0;
        });
        if (index !== -1) {
          that.$alert(
            "只允许删除其下没有子目录的目录，请检查您所勾选的目录是否含有子目录。",
            "删除失败",
            {
              confirmButtonText: "确定",
              type: "error",
              callback: (action) => {},
            }
          );
        } else {
          that
            .$confirm(
              "只允许删除其下没有资料项的目录，确认删除吗？",
              "确认提示",
              {
                distinguishCancelAndClose: true,
                confirmButtonText: "确认删除",
                cancelButtonText: "取消删除",
              }
            )
            .then(() => {
              deleteBimDataBankCategory({
                id: checkedKeys,
              }).then((res) => {
                //console.log(JSON.parse(JSON.stringify(res)));
                //console.log(555);
                if (res.data.success) {
                  that.$message({
                    message: "删除成功。",
                    type: "success",
                    offset: 100,
                    showClose: true,
                    duration: 1600,
                  });
                  that.refreshTree();
                } else {
                  //let message = res.data.msg || '删除失败了，请检查您要删除的目录下是否还有未删除的资料项。';
                  let message =
                    "删除失败了，请检查您要删除的目录下是否还有未删除的资料项。";
                  that.$alert(message, "删除失败", {
                    confirmButtonText: "确定",
                    type: "error",
                    callback: (action) => {},
                  });
                }
              });
            })
            .catch(function(err) {
              console.log(err);
            });
        }
      }
    },
    /* type为1表示设为常用，为2表示取消常用。*/
    updateCommonCategory(type, data) {
      // console.log(JSON.parse(JSON.stringify(type)));
      // console.log(JSON.parse(JSON.stringify(this.commonCategoryArr)));
      // console.log(JSON.parse(JSON.stringify(data)));
      // return false;
      let that = this;
      if (type == 1) {
        addBimDatabankCommonCategory({
          projectId: nowProjectId,
          categoryId: data.id,
        }).then((res) => {
          //console.log(JSON.parse(JSON.stringify(res)));
          //console.log(555);
          if (res.data.success) {
            that.$message({
              message: "成功添加常用目录。",
              type: "success",
              offset: 100,
              showClose: true,
              duration: 1600,
            });
            that.refreshTree();
          } else {
            that.$alert(message, "添加该目录为常用目录失败了，请再试一次吧。", {
              confirmButtonText: "确定",
              type: "error",
              callback: (action) => {},
            });
          }
        });
      } else if (type == 2) {
        this.$confirm("确定将该分类从常用分类列表中移除吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          // 删除树节点
          //axios请求删除节点代码
          let dccData = {
            projectId: nowProjectId,
            categoryId: data.id,
          };
          deleteBimDatabankCommonCategoryByCId(dccData).then((res) => {
            // console.log(JSON.parse(JSON.stringify(res)));
            // console.log(444444444444);
            if (res.data.success) {
              that.$message({
                message: "已从常用目录中移除该目录。",
                type: "success",
                offset: 100,
                showClose: true,
                duration: 1600,
              });
              that.refreshTree();
            } else {
              that.$alert(
                "从常用目录中移除该目录失败了，请再试一次吧~",
                "设置失败",
                {
                  confirmButtonText: "确定",
                  type: "error",
                  callback: (action) => {},
                }
              );
            }
          });
        });
      }
    },
    unusualDirectory(id) {
      // console.log(JSON.parse(JSON.stringify(this.commonCategoryArr)));
      // console.log(id);
      // console.log(this.commonCategoryArr.includes(id));
      return !this.commonCategoryArr.includes(id);
    },
    resetForm(parentId, pname) {
      //重置表单时，不重置父目录。
      (this.form = {
        name: "",
        parentId: parentId || 0,
        pname: pname || "根目录",
        description: "",
        sort: 1,
      }),
        (this.dialogFormVisible = false);
    },
    formSubmit() {
      //this.append();
      //console.log(JSON.parse(JSON.stringify(this.form)));
      let that = this;
      this.$refs.form.validate((valid) => {
        if (valid) {
          let postData = that.form;
          postData.projectId = nowProjectId; // 补上projectId。
          postData.pId = that.form.parentId; // 接口这里应该传pId。
          if (that.form?.id && that.form.id > 0) {
            //编辑
            // console.log(JSON.parse(JSON.stringify(postData)));
            // return false;
            editBimDataBankCategory(postData).then((res) => {
              if (res.data.success) {
                that.$notify({
                  title: "编辑成功。",
                  message: "",
                  type: "success",
                  duration: 960,
                  offset: 320,
                });
                // 由于涉及到排序，调试功能需要花一些时间，所以暂时改为直接刷新树。
                //为避免目录较多时，再次请求目录树并刷新一遍导致用户又得找一遍所需要添加的目录的父目录位置，所以这里直接通过程序改造目录树，让用户看到效果。
                // let newCategory={
                // 	id:res.data.data,
                // 	parentId:postData.pId||0,
                // 	text:postData.name,
                // 	pname:postData.pname||'根目录',
                // 	weight: postData.sort,
                // };
                // if(newCategory.parentId>0){

                // }else{

                // }
                that.refreshTree();
              } else {
                that.$alert("编辑目录失败了，请再试一次吧~", "添加失败", {
                  confirmButtonText: "确定",
                  type: "error",
                  callback: (action) => {},
                });
              }
              that.dialogFormVisible = false;
            });
          } else {
            //新增
            addBimDataBankCategory(postData).then((res) => {
              if (res.data.success && res.data.data > 0) {
                that.$notify({
                  title: "新增成功。",
                  message: "",
                  type: "success",
                  duration: 960,
                  offset: 320,
                });
                // 由于涉及到排序，调试功能需要花一些时间，所以暂时改为直接刷新树。
                //为避免目录较多时，再次请求目录树并刷新一遍导致用户又得找一遍所需要添加的目录的父目录位置，所以这里直接通过程序改造目录树，让用户看到效果。
                // let newCategory={
                // 	id:res.data.data,
                // 	parentId:postData.pId||0,
                // 	text:postData.name,
                // 	pname:postData.pname||'根目录',
                // 	weight: postData.sort,
                // };
                // if(newCategory.parentId>0){

                // }else{

                // }
                that.refreshTree();
              } else {
                that.$alert("新增目录失败了，请再试一次吧~", "添加失败", {
                  confirmButtonText: "确定",
                  type: "error",
                  callback: (action) => {},
                });
              }
              that.dialogFormVisible = false;
            });
          }
        }
      });

      // let newChild = {
      // 	id: id++,
      // 	label: this.form.name,
      // 	children: []
      // };

      // this.data.push(newChild);
      // this.dialogFormVisible = false;
    },
    // renderContent(h, {
    // 	node,
    // 	data,
    // 	store
    // }) {
    // 	return (
    // 	          <span class="custom-tree-node">
    // 	            <span class="item-title"><i class="el-icon-folder-opened"></i>{node.label}</span>
    // 	            <span class="operation-view">
    // 	              <el-button size="mini" type="text" on-click={ () => this.append(data) }><i class="el-icon-plus" />新增</el-button>
    // 				  <el-button size="mini" type="text" on-click={ () => this.edit(node, data) }><i class="el-icon-edit" />编辑</el-button>
    // 	              <el-button size="mini" type="text" on-click={ () => this.remove(node, data) }><i class="el-icon-delete" />删除</el-button>
    // 	            </span>
    // 	          </span>);
    // 	}
  },
  watch: {},
  destroyed() {},
};
